import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

import { BlockSection } from '../common/Common.styles';

export const BlockProductsSection = styled(BlockSection)`
    padding-bottom: ${getPurpurSpacing('400')};

    ${purpurMedia('lg')`
        padding-bottom: ${getPurpurSpacing('200')};
    `};
`;

export const BlockProductsSlide = styled.div`
    height: 100%;
    display: grid;
    padding-bottom: ${getPurpurSpacing('250')};
`;
